import { BOARD_COOP, BOARD_SOLO, L } from './config.ts';

/** Where things stand on the field — the numbers the scene builds its altars from. */

export interface CellSpot { index: number; r: number; c: number; x: number; z: number; w: number; d: number; floorY: number; topY: number }
export interface AltarSpot {
  cells: CellSpot[];
  rows: number; cols: number;
  /** Neighbour pairs (buff links), row-major, horizontal before vertical for each cell. */
  links: { a: number; b: number; vertical: boolean }[];
  /** Gameplay height of a resting orb (its shots start here). */
  gemY: number;
}
export interface AltarParams { cx: number; cz: number; rows: number; cols: number; cw: number; cd: number; gx: number; gz: number; y0: number; bh: number; th: number; orbScale: number | null }

export function altarSpot(p: AltarParams): AltarSpot {
  const cells: CellSpot[] = [];
  const baseTop = p.y0 + p.bh + 0.08, topY = baseTop + p.th + 0.06, floorY = baseTop + 0.004;
  for (let r = 0; r < p.rows; r++) for (let c = 0; c < p.cols; c++) {
    const dx = (c - (p.cols - 1) / 2) * (p.cw + p.gx), dz = (r - (p.rows - 1) / 2) * (p.cd + p.gz);
    cells.push({ index: cells.length, r, c, x: p.cx + dx, z: p.cz + dz, w: p.cw, d: p.cd, floorY, topY });
  }
  const links: AltarSpot['links'] = [];
  for (const A of cells) for (const [dr, dc] of [[0, 1], [1, 0]] as const) {
    const r = A.r + dr, c = A.c + dc;
    if (r < p.rows && c < p.cols) links.push({ a: A.index, b: r * p.cols + c, vertical: dr === 1 });
  }
  // a relic fills its well: the co-op well (1.18 m) is the reference; the partner's orbs are drawn at 0.72
  const s = p.orbScale ?? Math.max(1, p.cw / 1.18);
  return { cells, rows: p.rows, cols: p.cols, links, gemY: topY + 0.3 * s };
}

export interface Layout {
  coop: boolean;
  /**
   * One altar per seat. In co-op both seats stand on the same ground: every player's relics shoot
   * from where the near altar is, so the game is the same from either seat. Each client draws its
   * own board there and the ally's on the far plinth — that placement is only a picture.
   */
  altars: AltarSpot[];
  altarParams: AltarParams[];
  /** The near seal, as drawn. */
  seal: { x: number; y: number; z: number };
}

export function buildLayout(coop: boolean): Layout {
  // solo and co-op play on the same near altar (4×4): the same board to build, whatever the mode
  const grid = coop ? BOARD_COOP : BOARD_SOLO;
  const mine: AltarParams = { cx: 0, cz: 2.55, rows: grid.length, cols: grid[0].length, cw: 1.18, cd: 0.84, gx: 0.2, gz: 0.2, y0: 0, bh: 0.28, th: 0.22, orbScale: null };
  const params = coop ? [mine, mine] : [mine];
  const SZ = 6.05;
  return { coop, altars: params.map(altarSpot), altarParams: params, seal: { x: L.sealX, y: 0.62 * L.sealScale, z: SZ } };
}
